import React from "react";
import { motion } from "framer-motion";

import {
  MessageCircle,
  Clock3,
} from "lucide-react";

const statusColors = {
  Open: "bg-blue-500/20 text-blue-400",
  "In Progress":
    "bg-orange-500/20 text-orange-400",
  Resolved:
    "bg-green-500/20 text-green-400",
  Closed: "bg-gray-500/20 text-gray-400",
};

const TicketList = ({
  tickets,
  loading,
  selectedTicket,
  setSelectedTicket,
}) => {

  // ====================================
  // LOADING STATE
  // ====================================
  if (loading) {
    return (
      <div className="p-4 space-y-4">
        {[1, 2, 3, 4].map((item) => (
          <div
            key={item}
            className="
              h-28
              rounded-2xl
              bg-white/5
              animate-pulse
            "
          />
        ))}
      </div>
    );
  }

  // ====================================
  // EMPTY STATE
  // ====================================
  if (

!Array.isArray(
tickets
)

||

tickets.length===0

){
    return (
      <div
        className="
          h-full
          flex
          flex-col
          items-center
          justify-center
          text-center
          px-6
        "
      >
        <div
          className="
            w-20
            h-20
            rounded-full
            bg-gradient-to-r
            from-indigo-500/20
            to-purple-500/20
            flex
            items-center
            justify-center
            mb-4
          "
        >
          <MessageCircle
            size={36}
            className="text-indigo-400"
          />
        </div>

        <h3 className="text-white text-lg font-semibold">
          No Conversations Yet
        </h3>

        <p className="text-gray-400 mt-2 text-sm">
          Create your first support ticket
          and connect with the admin team.
        </p>
      </div>
    );
  }

  return (
    <div className="p-3 space-y-3">
      {(

Array.isArray(
tickets
)

?

tickets

:

[]

).map(

(ticket,index)=>{

        const isSelected =
          selectedTicket?._id === ticket._id;

        return (
          <motion.div
            key={ticket._id}
            initial={{
              opacity: 0,
              x: -10,
            }}
            animate={{
              opacity: 1,
              x: 0,
            }}
            transition={{
              delay: index * 0.05,
            }}
            onClick={() =>
              setSelectedTicket(ticket)
            }
            className={`
              relative
              p-4
              rounded-2xl
              cursor-pointer
              border
              transition-all
              duration-300
              group

              ${
                isSelected
                  ? `
                    bg-gradient-to-r
                    from-indigo-500/20
                    to-purple-500/20
                    border-indigo-500/40
                    shadow-lg
                    shadow-indigo-500/10
                  `
                  : `
                    bg-white/[0.03]
                    border-white/5
                    hover:bg-white/[0.06]
                    hover:border-white/10
                  `
              }
            `}
          >

            {/* UNREAD GLOW */}
            {ticket.userUnreadCount > 0 && (
              <div
                className="
                  absolute
                  top-3
                  right-3
                  w-3
                  h-3
                  rounded-full
                  bg-blue-400
                  animate-pulse
                  shadow-lg
                  shadow-blue-500/50
                "
              />
            )}

            {/* SUBJECT */}
            <div className="flex items-start justify-between gap-3">

              <div className="flex-1 min-w-0">

                <h3
                  className={`
                    font-semibold
                    truncate
                    ${
                      ticket.userUnreadCount > 0
                        ? "text-white"
                        : "text-gray-200"
                    }
                  `}
                >
                  {ticket.subject}
                </h3>

                <p
                  className="
                    text-sm
                    text-gray-400
                    mt-1
                    line-clamp-2
                  "
                >
                  {ticket.latestMessage}
                </p>
              </div>

              {/* UNREAD COUNT */}
              {ticket.userUnreadCount > 0 && (
                <div
                  className="
                    min-w-[24px]
                    h-6
                    px-2
                    rounded-full
                    bg-blue-500
                    text-white
                    text-xs
                    font-bold
                    flex
                    items-center
                    justify-center
                  "
                >
                  {ticket.userUnreadCount}
                </div>
              )}
            </div>

            {/* FOOTER */}
            <div
              className="
                mt-4
                flex
                items-center
                justify-between
                gap-2
              "
            >

              {/* STATUS */}
              <span
                className={`
                  px-3
                  py-1
                  rounded-full
                  text-xs
                  font-medium
                  ${statusColors[ticket.status]}
                `}
              >
                {ticket.status}
              </span>

              {/* TIME */}
              <div
                className="
                  flex
                  items-center
                  gap-1
                  text-xs
                  text-gray-500
                "
              >
                <Clock3 size={12} />

                {new Date(
                  ticket.lastMessageAt
                ).toLocaleDateString()}
              </div>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
};

export default TicketList;